import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { api, setToken } from "@/lib/api";
import { NexKeyMark } from "@/components/nexkey-logo";

export const Route = createFileRoute("/admin/login")({
  head: () => ({ meta: [{ title: "Admin login — NexKey.gg" }, { name: "robots", content: "noindex" }] }),
  component: Login,
});

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const r = await api.login(email, password);
      setToken(r.token);
      navigate({ to: "/admin" as any, replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-background px-4">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-border bg-card p-6 shadow-glow">
        <div className="mb-6 flex items-center gap-2 font-display text-xl font-bold">
          <NexKeyMark className="h-10 w-10" eager />
          <span className="text-gradient">NexKey</span>
          <span className="ml-1 rounded bg-accent/30 px-1.5 py-0.5 text-[10px] uppercase">admin</span>
        </div>
        <label className="block">
          <span className="text-xs font-medium text-muted-foreground">Email</span>
          <input
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="mt-1 w-full rounded-md border border-border bg-surface px-3 py-2 text-sm outline-none focus:border-primary"
          />
        </label>
        <label className="mt-4 block">
          <span className="text-xs font-medium text-muted-foreground">Password</span>
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="mt-1 w-full rounded-md border border-border bg-surface px-3 py-2 text-sm outline-none focus:border-primary"
          />
        </label>
        {error && <p className="mt-3 rounded-md bg-destructive/15 px-3 py-2 text-xs text-destructive-foreground">{error}</p>}
        <button
          type="submit"
          disabled={loading}
          className="mt-6 w-full rounded-md bg-primary-gradient px-4 py-2.5 text-sm font-semibold text-primary-foreground disabled:opacity-50"
        >
          {loading ? "Signing in…" : "Sign in"}
        </button>
        <p className="mt-4 text-center text-[11px] text-muted-foreground">
          Admin credentials are seeded via the backend (<code>npm run seed</code>).
        </p>
      </form>
    </div>
  );
}
